import React, { useState } from "react";
import { Card, Button, Badge } from "react-bootstrap";
import {
  TbEdit,
  TbMessage,
  TbPhone,
  TbMail,
  TbGenderMale,
  TbCake,
  TbMapPin,
  TbStar,
} from "react-icons/tb";

import EditBasicInfoModal from "../../modals/hrm/employee/employeedetails/EditBasicInfoModal";
import EditPersonalInfoModal from "../../modals/hrm/employee/employeedetails/EditPersonalInfoModal";
import EditEmergencyModal from "../../modals/hrm/employee/employeedetails/EditEmergencyModal";
import Doglas from "../../../assets/img/avatar/avatar-03.jpg";
import Doglas2 from "../../../assets/img/profiles/avatar-12-1.jpg";
import { FiEdit } from "react-icons/fi";
// import EditBasicInfoModal from "./EditBasicInfoModal";
// import EditPersonalInfoModal from "./EditPersonalInfoModal";
// import EditEmergencyModal from "./EditEmergencyModal";
import {
  TbId,
  TbCalendarTime,
  TbFlag,
  TbPray,
  TbUserHeart,
  TbBriefcase,
  TbBabyBottle,
} from "react-icons/tb";
import PersonalInfoModal from "../../modals/hrm/employee/employeedetails/PersonalInfoModal";
import EmergencyContactModal from "../../modals/hrm/employee/employeedetails/EmergencyContactModal";
const EmployeeLeftSidebar = () => {
  const [showBasic, setShowBasic] = useState(false);
  const [showPersonal, setShowPersonal] = useState(false);
  const [showEmergency, setShowEmergency] = useState(false);
const [showPersonalModal,setShowPersonalModal]=useState(false);
const [showEmergencyModal,setShowEmergencyModal]=useState(false);
  return (
    <>
      <Card className="shadow-sm border-0  profile-card">
        <Card.Body className="p-0">
          {/* HEADER */}
          <div className="profile-wrapper">
            {/* ORANGE HEADER ONLY */}
            <div className="profile-header"></div>

            {/* AVATAR */}
            <div className="avatar-wrapper">
              <img src={Doglas2} alt="" className="avatar-img" />
            </div>

            {/* CONTENT BELOW */}
      <div className="mt-5"
  style={{
    textAlign: "center",
    paddingTop: "8px"
  }}
>
  <h5
    style={{
      margin: "0 0 8px 0",
      fontSize: "18px",
      fontWeight: "700",
      color: "#0f172a",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "6px"
    }}
  >
    Stephan Peralt

    <span
      style={{
        width: "15px",
        height: "15px",
        borderRadius: "50%",
        background: "#22c55e",
        color: "#fff",
        fontSize: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 1
      }}
    >
      ✓
    </span>
  </h5>

  <div
    style={{
      display: "flex",
      justifyContent: "center",
      gap: "10px",
      flexWrap: "wrap"
    }}
  >
    <span
      style={{
        background: "#e5e7eb",
        padding: "4px 12px",
        borderRadius: "4px",
        fontSize: "12px",
        color: "#0f172a",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px"
      }}
    >
      <span style={{fontSize:"14px"}}>•</span>
      Software Developer
    </span>

    <span
      style={{
        background: "#e5e7eb",
        padding: "4px 12px",
        borderRadius: "4px",
        fontSize: "12px",
        color: "#0f172a"
      }}
    >
      10+ years of Experience
    </span>
  </div>
</div>
          </div>

          {/* CLIENT INFO */}
          <div className="section p-3 border-bottom ">
            <InfoRow icon={<TbId />} label="Client ID" value="CLT-0024" />
            <InfoRow icon={<TbStar />} label="Team" value="UI/UX Design" />
            <InfoRow
              icon={<TbCalendarTime />}
              label="Date Of Join"
              value="1st Jan 2023"
            />
            <InfoRow
              icon={
                <img
                  src={Doglas}
                  alt="Report Office"
                  className="report-avatar"
                />
              }
              label="Report Office"
              value="Doglas Martini"
            />
          </div>

          {/* BUTTONS */}
          <div className="p-3 d-flex gap-2 border-bottom">
            <Button
              className="flex-fill btn-dark-custom"
              onClick={() => setShowBasic(true)}
            >
              <TbEdit /> Edit Info
            </Button>

            <Button className="flex-fill btn-orange">
              <TbMessage /> Message
            </Button>
          </div>

          {/* BASIC INFO */}
          <div className="section p-3 border-bottom">
            <div className="d-flex justify-content-between">
              <SectionHeader title="Basic information" />
              <span className="edit-icon" onClick={() => setShowBasic(true)}>
                <FiEdit />
              </span>
            </div>
            <IconRow icon={<TbPhone />} label="Phone" value="(163) 2459 315" />

            <IconRow
              icon={<TbMail />}
              label="Email"
              value="[email protected]"
              link
            />

            <IconRow icon={<TbGenderMale />} label="Gender" value="Male" />

            <IconRow
              icon={<TbCake />}
              label="Birthday"
              value="24th July 2000"
            />

            <IconRow
              icon={<TbMapPin />}
              label="Address"
              value="1861 Bayonne Ave, Manchester, NJ, 08759"
            />
          </div>

          {/* PERSONAL INFO */}
          <div className="section p-3 border-bottom">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="section-title mb-0">Personal Information</h6>
        <span
className="edit-icon"
onClick={()=>setShowPersonalModal(true)}
>
<FiEdit />
</span>
            </div>
            <div style={{ padding: "12px 16px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginBottom: "18px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    color: "#64748b",
                    fontSize: "15px",
                  }}
                >
                  <TbId size={18} />
                  <span>Passport No</span>
                </div>
                <div style={{ fontSize: "15px", fontWeight: "500" }}>
                  QRET4566FGRT
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginBottom: "18px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    color: "#64748b",
                    fontSize: "15px",
                  }}
                >
                  <TbCalendarTime size={18} />
                  <span>Passport Exp Date</span>
                </div>
                <div style={{ fontSize: "15px", fontWeight: "500" }}>
                  15 May 2029
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginBottom: "18px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    color: "#64748b",
                    fontSize: "15px",
                  }}
                >
                  <TbFlag size={18} />
                  <span>Nationality</span>
                </div>
                <div style={{ fontSize: "15px", fontWeight: "500" }}>
                  Indian
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginBottom: "18px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    color: "#64748b",
                    fontSize: "15px",
                  }}
                >
                  <TbPray size={18} />
                  <span>Religion</span>
                </div>
                <div style={{ fontSize: "15px", fontWeight: "500" }}>
                  Christianity
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginBottom: "18px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    color: "#64748b",
                    fontSize: "15px",
                  }}
                >
                  <TbUserHeart size={18} />
                  <span>Marital status</span>
                </div>
                <div style={{ fontSize: "15px", fontWeight: "500" }}>Yes</div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginBottom: "18px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    color: "#64748b",
                    fontSize: "15px",
                  }}
                >
                  <TbBriefcase size={18} />
                  <span>Employment of spouse</span>
                </div>
                <div style={{ fontSize: "15px", fontWeight: "500" }}>No</div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    color: "#64748b",
                    fontSize: "15px",
                  }}
                >
                  <TbBabyBottle size={18} />
                  <span>No. of children</span>
                </div>
                <div style={{ fontSize: "15px", fontWeight: "500" }}>2</div>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>

      <div className="section emergency-section mt-3 mb-2 p-1">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="section-title mb-0">Emergency Contact Number</h6>
      <span
className="edit-icon"
onClick={()=>setShowEmergencyModal(true)}
>
<FiEdit />
</span>
        </div>

        <div className="emergency-box">
          {/* Primary */}
          <div className="emergency-row">
            <div>
              <small className="label">Primary</small>
              <div className="name">
                Adrian Peralt <span className="dot"></span> Father
              </div>
            </div>
            <div className="phone">+1 127 2685 598</div>
          </div>

          <hr />

          {/* Secondary */}
          <div className="emergency-row">
            <div>
              <small className="label">Secondary</small>
              <div className="name">
                Karen Wills <span className="dot"></span> Mother
              </div>
            </div>
            <div className="phone">+1 989 7774 787</div>
          </div>
        </div>
      </div>

      {/* MODALS */}
      <EditBasicInfoModal show={showBasic} onHide={() => setShowBasic(false)} />
      <EditPersonalInfoModal
        show={showPersonal}
        onHide={() => setShowPersonal(false)}
      />
      <EditEmergencyModal
        show={showEmergency}
        onHide={() => setShowEmergency(false)}
      />
      <PersonalInfoModal
show={showPersonalModal}
handleClose={()=>setShowPersonalModal(false)}
/>
<EmergencyContactModal
show={showEmergencyModal}
handleClose={()=>setShowEmergencyModal(false)}
/>
    </>
  );
};

export default EmployeeLeftSidebar;

/* 🔹 SMALL COMPONENTS */
const InfoRow = ({ icon, label, value }) => (
  <div className="info-row">
    {icon && <div className="icon-col">{icon}</div>}
    <div className="info-label">{label}</div>
    <div className="info-value">{value}</div>
  </div>
);

const IconRow = ({ icon, label, value, link }) => (
  <div className="icon-row">
    <div className="icon-col">{icon}</div>
    <div className="icon-details">
      <span className="icon-label">{label}</span>
      {link ? (
        <a href="#">{value}</a>
      ) : (
        <span className="icon-value">{value}</span>
      )}
    </div>
  </div>
);

const SectionHeader = ({ title }) => (
  <div className="d-flex justify-content-between align-items-center mb-3">
    <h6 className="section-title mb-0">{title}</h6>
    <style>
      {`
         /* WRAPPER */
.profile-wrapper {
  position: relative;
  text-align: center;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}

/* HEADER */
.profile-header {
  height: 120px;
  background: linear-gradient(135deg, #ff7a00, #ff9a00);
}

/* AVATAR */
.avatar-wrapper {
  position: absolute;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: 75px;
  height: 75px;
  border-radius: 50%;
  border: 4px solid #fff;
  overflow: hidden;
  background: #fff;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* CONTENT */
.profile-content {
  padding-top: 50px;
  padding-bottom: 15px;
}

/* NAME */
.name {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

.badge-pill.dark {
  background: #0f172a;
  color: #fff;
}

.badge-pill.light {
  background: #e2e8f0;
  color: #334155;
}

@media (max-width: 576px) {
  .profile-header {
    height: 100px;
  }

  .avatar-wrapper {
    width: 65px;
    height: 65px;
    top: 70px;
  }

  .profile-content {
    padding-top: 45px;
  }
}

.verified {
  color: #28c76f;
}

.badges {
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #eff2f7;
}

.info-row:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.icon-col {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f8fafc;
  color: #ff6b00;
  flex-shrink: 0;
}

.info-label {
  color: #64748b;
  font-size: 14px;
  flex: 1;
}

.info-value {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  text-align: right;
}

.icon-details {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 0;
  gap: 12px;
}

.icon-label {
  color: #64748b;
  font-size: 13px;
}

.icon-value,
.icon-row a {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  text-decoration: none;
  text-align: right;
}

.icon-row a:hover {
  text-decoration: underline;
}

.edit-icon {
  cursor: pointer;
}

.btn-orange {
  background: #ff6b00;
  border: none;
}

.btn-dark-custom {
  background: #0f172a;
  border: none;
}

.report-office {
  display: flex;
  align-items: center;
  gap: 8px;
}

.report-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  object-fit: cover;
}

.report-name {
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
}

.section-title {
  font-weight: 640;
  font-size: 17px;
  color: #1d2127;
}

.edit-icon {
  font-size: 14px;
  cursor: pointer;
  color: #333;
}

.emergency-box {
  border: 1px solid #e5e7eb;
  border-radius: 5px;
  padding: 12px;
  background: #fff;
}

.emergency-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label {
  font-size: 15px;
  color: #474c55;
}

.name {
  font-weight: 500;
  font-size: 15px;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone {
  font-size: 14px;
  color: #111827;
}

.dot {
  width: 6px;
  height: 6px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
}

hr {
  margin: 10px 0;
  border-color: #e5e7eb;
}

@media (max-width: 576px) {
  .info-row,
  .icon-row {
    flex-direction: column;
    gap: 4px;
  }

  .emergency-box {
    flex-direction: column;
    gap: 6px;
  }
}
      `}
    </style>
  </div>
);
